/* ══════════════════════════════════════════════════════════════════════
   Skön Cosmetics — skon-quiz-priority.js
   asset: assets/skon-quiz-priority.js
   Aggiornato: 10 luglio 2026 — 18:14 (Europe/Rome)
   Versione: 2.3

   Modifiche v2.3 (10 luglio 2026 — 18:14) — deploy ATOMICO con Worker v2.19.0 e skon-quiz.js
   v3.7.0:
   - SKON_RC_DISCOUNT: SK-RITORNO (50% sul secondo prodotto, DiscountCodeBxgy)
     sostituito da SK-RITORNO15 (EXTRA 15%, Basic). Non è più la sorgente dello
     sconto RC — che ora nasce dal master XTRA-CONFIG-RC via Worker — ma la
     rete di sicurezza usata solo se il Worker non risponde.
   - SKON_NC_DEBUG = false (produzione).

   Modifiche v2.1 (deploy ATOMICO con Worker v2.18.0, skon-quiz.js v3.5.0,
   nc-experience v2.4.0, email-content v2.16.0):
   - A/B sconto NC CONGELATO: enabled:false + forceGroup:'A'.
   - I valori code/pct dei due gruppi NON sono stati modificati: da v3.5.0 il
     codice e la percentuale consegnati all'utente vengono dal discount-master
     Shopify via Worker, non da qui. Questi valori restano come rete di
     sicurezza quando il Worker e' irraggiungibile.

   PRIORITÀ COMMERCIALI TIPS
   Scala: +5 (force-include) → 0 (neutro) → -5 (escluso)
   Tutti i prodotti a 0 di default.

   COME FUNZIONA:
   - I 4 prodotti CORE di ogni routine sono FISSI (definiti nelle 28 routine)
   - I 3 TIPS di ogni routine sono modulabili da questo file:
     · +5 = forza inclusione del prodotto come tip in tutte le routine compatibili
       (sostituisce il tip default a priorità più bassa)
     · -5 = esclude il prodotto da tutti i tips
     · 0  = neutro, comportamento default delle 28 routine
   - SKON_PRODUCT_SWAPS funziona globalmente (sia core che tips):
     se prodotto X è swappato con Y, ovunque appaia X compare Y

   DEPLOYMENT: caricare PRIMA di skon-quiz.js in quiz-main.liquid
══════════════════════════════════════════════════════════════════════ */

window.SKON_PRIORITY = {
  /* ── CLEAN ME UP ─────────────────────────────────────────────────── */
  cmu_mousse:             0,   // Clean Me Up Cleansing Mousse
  cmu_gel:                0,   // Clean Me Up Cleansing Gel
  cmu_balm:               0,   // Clean Me Up Cleansing Balm
  cmu_oil:                0,   // Clean Me Up Cleansing Oil
  cmu_essence:            0,   // Clean Me Up Energy Essence

  /* ── IMPERFECT ME ────────────────────────────────────────────────── */
  imperfect_gel_cleanser: 0,   // ImPerfect Cleansing Gel
  imperfect_exfol:        0,   // ImPerfect Exfoliating Lotion
  imperfect_cream:        0,   // ImPerfect Blemish Control Cream

  /* ── SIERI ──────────────────────────────────────────────────────── */
  arctic_waterfalls:      0,   // Arctic Waterfalls (Siero HA)
  better_late:            0,   // Better Late Than Never (Bakuchiol)
  bakuplex_serum:         0,   // Bakuplex Face Serum
  siero_imperfezioni:     0,   // Pimple Potion

  /* ── CONTORNO OCCHI ─────────────────────────────────────────────── */
  fy_eye_cream:           0,   // Forever Young Lifting Eye Cream
  staysoft_eye:           0,   // Stay Soft Hydrating Eye Gel

  /* ── CREME ──────────────────────────────────────────────────────── */
  forever_young_cream:    0,   // Forever Young Proaging Cream
  staysoft_cream:         0,   // Stay Soft Comfort Cream
  vitamin_blast:          0,   // Vitamin Blast
  over_the_moon:          0,   // Over The Moon
  bakuplex_crema_viso:    0,   // Bakuplex Face Cream

  /* ── SPF / MAKE-UP ──────────────────────────────────────────────── */
  ak_glow:                0,   // Abrakadabra Glow SPF30
  ak_matt:                0,   // Abrakadabra Soft Matt SPF30

  /* ── INTEGRATORI ────────────────────────────────────────────────── */
  booster_collagene:      0,   // Collagen Elixir
};

/* ══════════════════════════════════════════════════════════════════════
   SWAP GLOBALE — gestione out-of-stock / sostituzioni temporanee
   ──────────────────────────────────────────────────────────────────────
   Mappatura prodotto_originale → prodotto_sostitutivo.
   Se un prodotto è in questa mappa, viene SOSTITUITO ovunque appaia
   (sia nei core che nei tips di tutte le routine).

   USAGE:
   - Lasciare {} se nessuno swap è attivo
   - Aggiungere mappatura per gestire out-of-stock
   - Esempio: 'vitamin_blast': 'over_the_moon'
══════════════════════════════════════════════════════════════════════ */

window.SKON_PRODUCT_SWAPS = {
  // 'product_id_originale': 'product_id_sostitutivo'
};

/* ══════════════════════════════════════════════════════════════════════
   A/B TEST SCONTISTICA QUIZ — PARAMETRI COMMERCIALI
   ──────────────────────────────────────────────────────────────────────
   Modifica qui i codici Shopify e le percentuali di sconto per i NC.
   Lo script quiz legge questi valori automaticamente.

   REGOLE:
   - "code" deve corrispondere a un codice sconto attivo in Shopify
   - "pct" è la frazione decimale (0.25 = 25%)
   - I due gruppi devono essere distinti per avere dati A/B puliti

   ITERAZIONI PREVISTE (decommentare progressivamente):
   Lancio:         groupA: 0.25 / SK-QUIZ25  |  groupB: 0.30 / SK-QUIZ30
   Riduzione 1:    groupA: 0.20 / SK-QUIZ20  |  groupB: 0.25 / SK-QUIZ25
   Riduzione 2:    groupA: 0.15 / SK-QUIZ15  |  groupB: 0.20 / SK-QUIZ20

   Per disabilitare il test: enabled:false (+ forceGroup 'A' o 'B').

   ATTENZIONE (v2.1): da skon-quiz.js v3.5.0 il codice sconto e la percentuale
   consegnati al visitatore arrivano dal discount-master Shopify
   (XTRA-CONFIG-NC-[NON-CANCELLARE]) via Worker, NON da questo file.
   Riattivare enabled:true fara' tornare la randomizzazione del GRUPPO (etichetta
   analitica, cookie, QUIZ_DISCOUNT_GROUP, GA4) ma NON cambiera' lo sconto:
   tutti continueranno a ricevere la percentuale del master.
   Per un vero A/B sulla percentuale servono due discount-master distinti.

   I valori code/pct qui sotto restano usati SOLO come rete di sicurezza
   quando il Worker non risponde (vedi NC_NETWORK_FALLBACK in skon-quiz.js).
══════════════════════════════════════════════════════════════════════ */

window.SKON_AB_CONFIG = {
  // v2.1 — CONGELATO. false → nessuna randomizzazione, tutti in forceGroup.
  enabled: false,

  // Usato solo con enabled:false. Valori: 'A' o 'B'.
  // 'A' per coerenza con la convenzione gia' adottata in skon-fs-config.js.
  forceGroup: 'A',

  groupA: {
    code: 'SK-QUIZ25',  // codice sconto Shopify — gruppo A
    pct:  0.25,         // 25% — sconto applicato al checkout
  },

  groupB: {
    code: 'SK-QUIZ30',  // codice sconto Shopify — gruppo B
    pct:  0.30,         // 30% — sconto applicato al checkout
  },
};

/* ══════════════════════════════════════════════════════════════════════
   SCONTO RC — CONFIGURAZIONE
   ──────────────────────────────────────────────────────────────────────
   Editabile da marketing senza toccare il codice principale.
   Letto da skon-quiz.js in getEffectiveRCDiscount().
══════════════════════════════════════════════════════════════════════ */

/* v2.3 (10 lug 2026) — SK-RITORNO ("secondo prodotto a metà prezzo") è
   sostituito da un EXTRA 15% personale, generato dal Worker da un master RC
   su Shopify (XTRA-CONFIG-RC), esattamente come per gli NC.
   Questi valori NON sono più la sorgente dello sconto: sono la RETE DI
   SICUREZZA usata solo se il Worker non risponde, e coincidono con
   RC_QUIZ_FALLBACK_CODE lato Worker. */
window.SKON_RC_DISCOUNT = {
  code:        'SK-RITORNO15',
  pct:         0.15,
  description: 'Un EXTRA 15% sui prodotti singoli, oltre alle promozioni già attive',
};

/* ══════════════════════════════════════════════════════════════════════
   TOGGLE NC / RC EXPERIENCE
   SKON_NC_EXPERIENCE  true  = NC Experience attiva
   SKON_RC_EXPERIENCE  false = RC Experience spenta (non ancora implementata)
   SKON_NC_DEBUG       true  = visibile SOLO con ?skon_debug=1 nell'URL
                       false = visibile per tutti (impostare al lancio)
══════════════════════════════════════════════════════════════════════ */

window.SKON_NC_EXPERIENCE = false;
window.SKON_RC_EXPERIENCE = false;
window.SKON_NC_DEBUG      = false;  /* v2.3 — produzione (10 lug 2026) */
window.SKON_QUIZ_INVITES = false;

/* ══════════════════════════════════════════════════════════════════════
   NC EXPERIENCE POST-QUIZ  [v2.2 — 10 lug 2026]
   ──────────────────────────────────────────────────────────────────────
   false = un lead che ha gia' fatto il quiz non vede nulla sul PDP
           (comportamento identico a prima del 10 lug, quando era RC).
   true  = vede la nota col SUO codice e il SUO prezzo, e l'exit-intent.

   Perche' un flag: fino al 9 lug chi aveva fatto il quiz era classificato
   RC e usciva da _runPdp(). Il ramo _renderPriceNote() non e' MAI stato
   eseguito in produzione. Prima di accendere codice mai girato, si guarda.

   NB: skon-pdp-live-price.js non dipende da questo flag ne' da SkonID:
   lo stack prezzi lo vedono tutti, sempre, RC compresi.
══════════════════════════════════════════════════════════════════════ */
window.SKON_NC_POSTQUIZ   = true;